// extracted by mini-css-extract-plugin
export default {"flat":"styles_flat__6NMai","insideFlat":"styles_insideFlat__o5ydA"};